// onde definimos as regras baseadas no status do simulado
// aqui se define o que aparece e em que etapa

const RULES_BY_STATUS = {

  // Arquivado -- tem que sumir visualização
  0: { 
    showRanking: false, 
    showExams: false, 
    showLocalProva: false, 
    showCartao: false, 
    showGabarito: false },


  // Período de inscrição
  1: { 
    showRanking: false, 
    showExams: false, 
    showLocalProva: true,  
    showCartao: false,  
    showGabarito: false },
  

  // Aguardando aplicação
  2: { 
    showRanking: false, 
    showExams: false,  
    showLocalProva: true,  
    showCartao: false,  
    showGabarito: false },
  

  // Período de recursos
  3: { 
    showRanking: true,  
    showExams: true,  
    showLocalProva: true,  
    showCartao: false,  
    showGabarito: true },
  

  // Aguardando leitura 
  4: { 
    showRanking: false,  
    showExams: true,  
    showLocalProva: true,  
    showCartao: true,  
    showGabarito: true },
  

  // Análise de recursos
  5: { 
    showRanking: false,  
    showExams: true,  
    showLocalProva: true,  
    showCartao: true,  
    showGabarito: true  },
  

  // Cálculo da TRI
  6: {
    showRanking: false,
    showExams: true,
    showLocalProva: true,
    showCartao: true,
    showGabarito: true  },


  // Finalizado
  7: {
    showRanking: true,
    showExams: true,
    showLocalProva: true,
    showCartao: true,
    showGabarito: true  },

};

export function getSimuladoRules(status) {
  const rules = RULES_BY_STATUS[status] ?? RULES_BY_STATUS[0];
  return {
    ...rules,
    getMarchState: (n) =>
      n <= status      ? 'completed' :
      n === status + 1 ? 'next'      : 'upcoming',
  };
}
